import React, { Component } from 'react';
import { auth } from '../firebase';
import { List, Card, Button } from "antd";
import {
    Link,
  } from 'react-router-dom'

  const data = [
    {
      title: 'Screensavers',
      link: `/dashboard/screensavers/`
    },
    {
      title: 'Events',
      link: `/dashboard/events/`
    },
    {
      title: 'Projects',
      link: `/dashboard/projects/`
    },
  ];

class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
    }

  }
  componentDidMount() {
    auth.onAuthStateChanged((user) => {
      if (user) {
        this.setState({email: user.email})
      }
    });
  }

    render() {
        return (
            <div>
                <h1 className="block">Dashboard</h1>
      
                <List
                 className="dash"
                 grid={{ gutter: 4, column: 3 }}
                 dataSource={data}
                 renderItem={item => (
                   <List.Item>
            <Card title={item.title}>
            <Button type="primary" size="large" ><Link to={item.link}>Manage {item.title}</Link></Button><br/>
            </Card>
          </List.Item>
        )}
        />

        {process.env.NODE_ENV !== 'production' ? <Button className="margin-row" type="primary" size="large" ><Link to='admin'>admin</Link></Button>:<div/>}
            </div>
        );

    }

}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/dashboard.js